import React, { useState } from 'react';
import { ChevronRightIcon, ChevronUpIcon } from 'lucide-react';
import { sports } from '../../data/sports';
import type { City } from '../../types/landing';
import { venueSportUrl } from '../../utils/inventory';
import { prototypeNavigate } from '../../utils/prototypeNav';
import { SectionHeading } from '../SectionHeading';
export function MetroProgramDirectory({
  city
}: {
  city: City;
}) {
  const [closed, setClosed] = useState<string[]>([]);
  const toggle = (id: string) => setClosed(c => c.includes(id) ? c.filter(x => x !== id) : [...c, id]);
  return <section aria-labelledby="browse-all" className="px-5 py-12 md:px-10 md:py-14" data-id="element-114" data-mp="1llf4l4ckzhem">
      <SectionHeading id="browse-all" data-id="element-115" data-mp="1gmlr3bxanqeg">Browse all programs in {city.name}</SectionHeading>
      <div className="mt-8 grid items-start gap-6 md:grid-cols-2 lg:grid-cols-3" data-id="element-116" data-mp="1gkr4lt6djq89">
        {city.areas.map(area => {
        const isOpen = !closed.includes(area.id);
        return <div key={area.id} data-id="element-117" data-mp="17o0b9oj7iphd">
              <button type="button" onClick={() => toggle(area.id)} aria-expanded={isOpen} className="relative flex h-10 w-full items-center justify-center bg-brand-sky pr-14 text-xs font-bold text-white transition-colors duration-150 hover:bg-brand-skyDark" data-id="element-118" data-mp="ov9q0tqxhpik">
                <span className="truncate px-3" data-id="element-119" data-mp="jwgeh6v7c8l1">{area.name}</span>
                <span className="absolute inset-y-0 right-0 flex w-14 items-center justify-center bg-brand-navy [clip-path:polygon(12px_0,100%_0,100%_100%,0_100%)]" data-id="element-120" data-mp="17kzphu5myzgt">
                  <ChevronUpIcon className={`h-4 w-4 transition-transform duration-200 ${isOpen ? '' : 'rotate-180'}`} aria-hidden="true" data-id="element-121" data-mp="1ci85pp784tff" />
                </span>
              </button>
              {isOpen && <ul className="mt-2 space-y-3" data-id="element-122" data-mp="3jb20zfu1v5dt">
                  {area.venues.map(v => {
              const offered = sports.filter(s => v.programs.some(p => p.sport === s.slug));
              return <li key={v.id} data-id="element-123" data-mp="1tu6gtllharmm">
                        <a href={`/${city.slug}/${v.id}`} onClick={e => {
                  e.preventDefault();
                  prototypeNavigate(v.name, `/${city.slug}/${v.id}`);
                }} className="inline-flex items-center gap-1 text-xs font-bold text-brand-skyDark hover:underline" data-id="element-124" data-mp="1tt54zewn213u">
                          {v.name} <ChevronRightIcon className="h-3 w-3" aria-hidden="true" data-id="element-125" data-mp="1b4gkgu22hxsl" />
                        </a>
                        <ul className="mt-1 space-y-1 pl-3" data-id="element-126" data-mp="163j48n0mbdtq">
                          {offered.map(s => {
                    const url = venueSportUrl(city.slug, v.id, s.slug);
                    return <li key={s.slug} data-id="element-127" data-mp="w893e2lyhchj">
                                <a href={url} onClick={e => {
                        e.preventDefault();
                        prototypeNavigate(`${s.name} at ${v.name}`, url);
                      }} className="inline-flex items-center gap-1 text-xs font-semibold text-brand-skyDark hover:underline" data-id="element-128" data-mp="2vjil6qaha7jx">
                                  {s.name} <ChevronRightIcon className="h-3 w-3" aria-hidden="true" data-id="element-129" data-mp="37trln85f9u3k" />
                                </a>
                              </li>;
                  })}
                        </ul>
                      </li>;
            })}
                </ul>}
            </div>;
      })}
      </div>
    </section>;
}